import apiClient from './apiClient';

// Visual Strategies API
export const visualStrategiesApi = {
  // List user's strategies
  listStrategies: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.limit) {
      params.append('limit', filters.limit);
    }
    if (filters.cursor) {
      params.append('cursor', filters.cursor);
    }
    if (filters.tags?.length) {
      params.append('tags', filters.tags.join(','));
    }
    if (filters.complexity) {
      params.append('complexity', filters.complexity);
    }
    if (filters.timeframe) {
      params.append('timeframe', filters.timeframe);
    }
    
    const response = await apiClient.get(`/visual-strategies?${params.toString()}`);
    return response.data;
  },

  // Get specific strategy
  getStrategy: async (strategyId) => {
    const response = await apiClient.get(`/visual-strategies/${strategyId}`);
    return response.data;
  },

  // Create new strategy
  createStrategy: async (strategyData) => {
    const response = await apiClient.post('/visual-strategies', strategyData);
    return response.data;
  },

  // Update strategy
  updateStrategy: async (strategyId, updates) => {
    const response = await apiClient.put(`/visual-strategies/${strategyId}`, updates);
    return response.data;
  },

  // Delete strategy
  deleteStrategy: async (strategyId) => {
    const response = await apiClient.delete(`/visual-strategies/${strategyId}`);
    return response.data;
  },

  // Get public templates
  getPublicTemplates: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.limit) {
      params.append('limit', filters.limit);
    }
    if (filters.cursor) {
      params.append('cursor', filters.cursor);
    }
    
    const response = await apiClient.get(`/visual-strategies/public?${params.toString()}`);
    return response.data;
  },

  // Compile strategy to executable
  compileStrategy: async (strategyId) => {
    const response = await apiClient.post(`/visual-strategies/${strategyId}/compile`);
    return response.data;
  }
};

export default visualStrategiesApi; 